import React, { useState, useRef, useEffect } from 'react'
import Button from '@mui/material/Button';
import api from "../../controller/api"
import { toast, Toaster } from 'sonner';
import { BiLoader } from "react-icons/bi"
import { useNavigate } from "react-router-dom"

export default function CouponAdd() {
    const [couponName, setCouponName] = useState("")
    const [discount, setDiscount] = useState("")
    const [validity, setValidity] = useState("")
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()

    const addCoupon = async () => {
        setLoading(true)

        const data = {
            name: couponName,
            discount: discount,
            validity: validity
        }

        try {
            await api.post("/coupon/create", data)
            toast.success("Coupon added")
            setCouponName("")
            setDiscount("")
            setValidity("")
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className='manage'>
            <h2 style={{ display: "flex", justifyContent: "space-between" }}>
                Add Coupon
                <Button variant="contained" onClick={() => navigate("/dashboard/coupon")}>Back to List</Button>
            </h2>
            <div className='add-product'>
                <Toaster richColors position="top-center" />
                <div className='form-row'>
                    <div className='inpt-row'>
                        <label>Coupon Name</label>
                        <input type='text' value={couponName} onChange={(e) => setCouponName(e.target.value)} required />
                    </div>
                </div>
                <div className='form-row'>
                    <div className='inpt-row'>
                        <label>Coupon Name</label>
                        <input type='text' value={discount} onChange={(e) => setDiscount(e.target.value)} required />
                    </div>
                </div>
                <div className='form-row'>
                    <div className='inpt-row'>
                        <label>Validity</label>
                        <input type='date' value={validity} onChange={(e) => setValidity(e.target.value)} required />
                    </div>
                </div>
                <Button type='submit' variant="contained" disableElevation onClick={addCoupon}>
                    {loading ? <BiLoader size={24} className='animate-spin' /> : "Add Category"}
                </Button>
            </div>
        </div>
    )
}
